import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';
import { IBank } from 'app/shared/model/bank.model';

export interface IDepositTransaction {
  id?: number;
  code?: string;
  amount?: number;
  isApproved?: boolean | null;
  note?: string | null;
  createdDate?: dayjs.Dayjs | null;
  user?: IUser | null;
  bank?: IBank | null;
  channel?: string | null;
  expired?: boolean | null;
}

export const defaultValue: Readonly<IDepositTransaction> = {
  isApproved: false,
};
